import React from "react";
import { LSResultItemSkeleton } from "./LSResultItemSkeleton";

export interface LSResultItemSkeletonList {
  pageSize: number;
  hideCheckbox?: boolean;
  hideActions?: boolean;
}

export const LSResultItemSkeletonList: React.FC<LSResultItemSkeletonList> = ({
  pageSize,
  hideCheckbox = true,
  hideActions = true,
}) => {
  return (
    <>
      {Array.from({ length: pageSize }).map((_, i) => (
        <LSResultItemSkeleton
          key={i}
          hideActions={hideActions}
          hideCheckbox={hideCheckbox}
        />
      ))}
    </>
  );
};
